import Cookies from 'universal-cookie';
import { encryptionData, decryptionData } from "../Encryption";
import {IsCookieEncryption} from "../AppSetting";

/**
 * Function to create a cookie for the logged in user
 * @params: props (object): contains name, value and options mentioned below for the cookie
 *
 * @returns: nothing
 *
 * options (object): Support all the cookie options from RFC 6265
                     path (string): cookie path, use / as the path if you want your cookie to be accessible on all pages
                     expires (Date): absolute expiration date for the cookie
                     maxAge (number): relative max age of the cookie from when the client receives it in seconds
                     domain (string): domain for the cookie (sub.domain.com or .allsubdomains.com)
                     secure (boolean): Is only accessible through HTTPS?
                     httpOnly (boolean): Can only the server access the cookie?
                     sameSite (boolean|none|lax|strict): Strict or Lax enforcement
 *
 */

const cookies = new Cookies();
export const CreateCookie = (props) => {
    let cookieValue = props.cookieValue;
    let cookieName = props.cookieName;

    // check if encryption is required for the cookie.
    if(IsCookieEncryption){
        cookieValue = encryptionData(cookieValue,1);
    }
    cookies.set(cookieName, cookieValue,
        {
            path: props.path,
            maxAge: props.expirationTime * 60,
        });
};

/**
 * Get a cookie value
 * @params: cookieName (string): cookie name
            doNotParse (boolean): do not convert the cookie into an object no matter what

 * @returns: value (string||object) of the cookie
 *
 * **/
export function getCookie(cookieName, doNotParse=false){
    if(IsCookieEncryption){
        const cookieValue = cookies.get(cookieName, {doNotParse: doNotParse})
        if(cookieValue)
            return decryptionData(cookieValue,true);
    }
    else{
        return cookies.get(cookieName, {doNotParse: doNotParse})
    }
    return undefined;
}

/**
 * Get all cookies
 * @params: doNotParse (boolean): do not convert the cookie into an object no matter what
 *
 * @returns: object
 *
 */
export const getAllCookies = (doNotParse=false) => {
    const cookieValue = cookies.getAll({doNotParse: doNotParse});
    if(IsCookieEncryption){
        return decryptionData(cookieValue,true);
    }
    return cookieValue;
};

/**
 * Remove cookie
 * @params: name (string): cookie name
 *          options (object): Support all the cookie options from RFC 6265
                              path (string): cookie path, use / as the path if you want your cookie to be accessible on all pages
                              expires (Date): absolute expiration date for the cookie
                              maxAge (number): relative max age of the cookie from when the client receives it in seconds
                              domain (string): domain for the cookie (sub.domain.com or .allsubdomains.com)
                              secure (boolean): Is only accessible through HTTPS?
                              httpOnly (boolean): Can only the server access the cookie?
                              sameSite (boolean|none|lax|strict): Strict or Lax enforcement.
 *
 * @returns: nothing
 */
export const removeCookie = (cookieName, options={}) => {
    cookies.remove(cookieName, options);
};


export const removeAllCookies = (doNotParse=false) => {
    const cookieValue = cookies.getAll({doNotParse: doNotParse});
    cookieValue.forEach(element => {
        cookies.remove(element.cookieName, {});
    });
};

export const removeAllCookiess = () => {
    Object.keys(cookies.cookies).forEach(element => {
        cookies.remove(element, {});
    });
};

export const isCookieExist = (cookieName) => {
    const cookieDetail = getCookie(cookieName);
    if(cookieDetail){
        return true;
    }
    return false;
}

export const setCookie = (props) => {
    let cookieValue = props.cookieValue;
    let cookieName = props.cookieName;
    if (IsCookieEncryption) {
        cookieValue = encryptionData(cookieValue, 1);
    }
    cookies.set(cookieName, cookieValue);
}